module.exports = __webpack_public_path__ + "static/media/tyrill-sample-card.1b4a0f9f.png";